import {NgModule} from "@angular/core";
import {IonicPageModule} from "ionic-angular";
import {HeaderTitleComponent} from "./header-title";
import {TranslateModule} from "@ngx-translate/core";
import {NetworkComponentModule} from '../network-button/network-button.module';

@NgModule({
    declarations: [
        HeaderTitleComponent,
    ],
    imports: [
        NetworkComponentModule,
        TranslateModule.forChild(),
        IonicPageModule.forChild(HeaderTitleComponent),
    ],
    exports: [
        HeaderTitleComponent
    ]
})
export class HeaderTitleComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/header-title/header-title.module.ts